import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "controls-footer__wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Cta = _resolveComponent("Cta")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Cta, {
      type: "secondary",
      displayBlock: true,
      largeLabelAtMobile: true,
      size: "lg",
      label: "Done",
      iconAlignment: "left",
      route: _ctx.backToRoute,
      onUpdateRoute: $options.handleUpdateRoute
    }, null, 8 /* PROPS */, ["route", "onUpdateRoute"])
  ]))
}